import { UpdatedResultDto } from '../updated-result-dto';

export class DimensionResultDto extends UpdatedResultDto {
    dimensionCode: string;
    dimensionOptionCode: string;
    composite: string;
    completeComposite: boolean;
    dimensionTitle: string;
    dimensionOptionTitle: string;
}
